import { render, staticRenderFns } from "./GradeSelector.vue?vue&type=template&id=1ca5a9ac&scoped=true&"
import script from "./GradeSelector.vue?vue&type=script&lang=js&"
export * from "./GradeSelector.vue?vue&type=script&lang=js&"
import style0 from "./GradeSelector.vue?vue&type=style&index=0&id=1ca5a9ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca5a9ac",
  null
  
)

export default component.exports